var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "col-12 px-0 h-100" }, [
    _c(
      "div",
      {
        staticClass:
          "container mw-100 border-gray h-100 recommended-mobile-tile mb-0",
      },
      [
        _c("div", { staticClass: "col-12 px-0 bg-header-tile" }, [
          _c("div", { staticClass: "row" }, [
            _vm.offer.showPicto5G
              ? _c("img", {
                  staticClass: "logo-5g",
                  attrs: { src: _vm.offer.picto5gSrc, alt: "" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("section", { staticClass: "pb-2" }, [
              _vm.offer.banner
                ? _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      { staticClass: "row align-items-center reco-banner" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-auto p-0 padding-bottom-banner" },
                          [
                            _c(
                              "div",
                              { staticClass: "ob1-tag ob1-tag-primary" },
                              [_c("span", [_vm._v(_vm._s(_vm.offer.banner))])]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.offer.timerEndDateInMilliseconds
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-auto p-0 padding-left-tag padding-bottom-banner",
                              },
                              [
                                _c("timer", {
                                  attrs: {
                                    "end-date-in-milliseconds":
                                      _vm.offer.timerEndDateInMilliseconds,
                                    color: _vm.offer.countDownColor
                                      ? _vm.offer.countDownColor
                                      : "text-dark",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ])
                : _c("div", { staticClass: "col-12 reco-banner" }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 pb-1 text-center" }, [
              _c(
                "div",
                { staticClass: "reco-title h4 text-primary pb-0 mb-0" },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.offer.name) +
                      "\n                    "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 pb-2 d-flex justify-content-center" },
              [
                _c(
                  "a",
                  {
                    staticClass: "ob1-link-arrow",
                    attrs: {
                      href: _vm.offer.foLink,
                      "data-oevent-category":
                        _vm.offer.foHighlightedTms.category,
                      "data-oevent-action": _vm.offer.foHighlightedTms.action,
                      "data-oevent-label": _vm.offer.foHighlightedTms.label,
                    },
                  },
                  [_vm._v(_vm._s(_vm.offer.foLinkLabel))]
                ),
              ]
            ),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-12 pt-1 text-center" },
              [
                _c("ob1-prix", {
                  attrs: {
                    custom: "reco-ob1-price h3 text-dark",
                    duration: _vm.offer.price.duration,
                    "initial-price": _vm.offer.price.initialPrice,
                    "is-mini": _vm.offer.price.mini,
                    price: _vm.offer.price.price,
                    "price-details": _vm.offer.price.priceDetails,
                    "show-by-month": _vm.offer.price.showByMonth,
                    "show-end-of-promotion-price":
                      _vm.offer.price.showEndOfPromotionPrice,
                    "show-from": _vm.offer.price.showFrom,
                    "show-promo-duration": _vm.offer.price.showPromoDuration,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 pb-2 text-center" }, [
              _c("strong", [_vm._v(_vm._s(_vm.offer.commitment))]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "col-12 text-center px-0",
                class: _vm.offerClaimsClass,
              },
              [
                _vm.offer.claims.length > 0
                  ? _c(
                      "div",
                      { staticClass: "reco-claim" },
                      _vm._l(_vm.offer.claims, function (claim) {
                        return _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "py-1 px-1",
                              class: claim.image
                                ? _vm.offer.claimBgColor
                                : "bg-white",
                            },
                            [
                              claim.image
                                ? _c("div", [
                                    _c("img", {
                                      staticClass: "reco-mobile-claim-img",
                                      attrs: {
                                        loading: "lazy",
                                        src: claim.image.url,
                                        alt: claim.image.alt,
                                      },
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(claim.attributes, function (attribute) {
                                return _c("div", [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "mb-0 px-2 d-flex align-items-center justify-content-center",
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(attribute.textHtml),
                                        },
                                      }),
                                    ]
                                  ),
                                ])
                              }),
                            ],
                            2
                          ),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 py-0 text-center" }, [
      _c("hr", { staticClass: "separator separator--gray4 my-0" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }